import { useMarketStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useTopOfPageContextStore } from "@faire/deprecated-retailer-visitor-shared/stores/ui/TopOfPageContextStore";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { useCallback, useMemo } from "react";

export const useTopOfPageContent = () => {
  const { isDesktopAndAbove } = useViewport();
  const { isShowingCountdownBanner, isPreshowOrLive } = useMarketStore();
  const [
    { height, shouldKeepTopNavVisible, bannerHeight, isBannerInView },
    setStore,
  ] = useTopOfPageContextStore([
    "height",
    "shouldKeepTopNavVisible",
    "bannerHeight",
    "isBannerInView",
  ]);

  const promoBannerHeight = useMemo(() => {
    if (isPreshowOrLive && isDesktopAndAbove) {
      return bannerHeight;
    }
    return isBannerInView ? bannerHeight : 0;
  }, [bannerHeight, isDesktopAndAbove, isPreshowOrLive, isBannerInView]);

  const setHeaderHeight = useCallback(
    (height: number | undefined) => {
      if (height !== undefined) {
        setStore({ height });
      }
    },
    [setStore]
  );

  const setShouldKeepTopNavVisible = useCallback(
    (newValue: boolean) => {
      setStore({ shouldKeepTopNavVisible: newValue });
    },
    [setStore]
  );

  const headerPlusPromoBannerHeight = height + promoBannerHeight;

  const topPosition =
    isDesktopAndAbove && isShowingCountdownBanner ? bannerHeight : 0;

  return {
    headerHeight: height,
    headerPlusPromoBannerHeight,
    heightWithHeaderOrMarketBanner:
      isShowingCountdownBanner && isDesktopAndAbove
        ? promoBannerHeight
        : height,
    heightWithoutPromoBannerExceptMarket:
      isShowingCountdownBanner && isDesktopAndAbove
        ? headerPlusPromoBannerHeight
        : height,
    setHeaderHeight,
    setShouldKeepTopNavVisible,
    shouldKeepTopNavVisible,
    promoBannerHeight,
    topPosition,
  };
};
